<template>
    <div class="main_banner_box">
       <div class="container">
            <main-banner-carousel></main-banner-carousel>
            <main-banner-star></main-banner-star>
        </div>
    </div>
</template>

<script>
export default {
    components: {
        mainBannerCarousel: () => import("@/components/mainBannerCarousel"),
        mainBannerStar: () => import("@/components/mainBannerStar"),
    }
}
</script>

<style scoped>
/* 组件盒子 */
.main_banner_box{
    background-color: #fff;
}
</style>
